var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.marker)?_c('GmapMap',{ref:"map",style:(_vm.style),attrs:{"center":_vm.marker,"zoom":14}},[_c('DeviceMarker',{attrs:{"doc":_vm.doc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }